import { apiClient } from './client';

export async function generateAdminLink (shopId: number | string, intendedUrl?: string): Promise<string> {
  const { data } = await apiClient.post('/proxy/admin-link', {
    shop_id: shopId,
    intended_url: intendedUrl,
  });
  return data.url;
}
